module.exports = __webpack_public_path__ + "img/method-background.ea63e009.png";